import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ZpDataService } from '../services/zp-data.service';
import {Router} from '@angular/router';
import { ThemeService } from '../theme/theme-service.service';

@Component({
  selector: 'app-payment-subcription',
  templateUrl: './payment-subcription.component.html',
  styleUrls: ['./payment-subcription.component.scss']
})
export class PaymentSubcriptionComponent implements OnInit {
private user;
private handled;
  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private ZpDataService: ZpDataService, private router:Router,
    public themeService: ThemeService) { }

  async ngOnInit() {
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.user = await this.ZpDataService.getUser();
  }

  openPortal() {
    var chargebeeInstance = window['Chargebee'].init({
      site: this.ZpDataService.chargeBeeSite
    });
    let self = this;
    chargebeeInstance.setPortalSession(() => {
      // Hit your end point that returns portal session object as response
      // This sample end point will call the below api
      // https://apidocs.chargebee.com/docs/api/portal_sessions#create_a_portal_session
      return self.ZpDataService.chargeBeePortal({});
    });
    self.handled = false;
    window.setTimeout(function () {
      chargebeeInstance.createChargebeePortal().open({
        loaded: () => {

        },
        close: async () => {
          let subStatus = await self.ZpDataService.getSubscriptionStatus();
          if(subStatus.active && subStatus.method && subStatus.method.customerId){
            let result = await self.ZpDataService.chargeBeeSaveSubscriptionId(subStatus.method.customerId);
            if(result.success){
              self.handled = true;
            }
          }
          if(self.handled){
            if(!self.user || !self.user.userType){
              this.close();
              self.ZpDataService.logout();
            }
            switch(self.user.userType){
              case 'professionalManager':
                self.router.navigate(['/professional-manager-home-page']);
                break;
              case 'professional':
                self.router.navigate(['/professional-home-page']);
                break;
              case 'planHolder':
              default:
                self.router.navigate(['/home']);
            }
          }else{
            this.close();
            self.ZpDataService.logout();
          }
        },
        // paymentSourceAdd: (status) => {
        //   console.log("payment source add" + status);
        // },
        // paymentSourceUpdate: (status) => {
        //   console.log("payment source update" + status);
        // },
        // paymentSourceRemove: (status) => {
        //   console.log("payment source removed");
        // },
        // scheduledPauseRemoved:(data)=>{
        //   console.log("scheduledPauseRemoved")
        //
        // },
        // subscriptionPaused:(data)=>{
        //   console.log("subscriptionPaused")
        //
        // },
        // subscriptionResumed:(data)=>{
        //   console.log("subscriptionResumed")
        //
        // },
        // subscriptionCancelled:(data)=>{
        //   console.log("subscriptionCancelled")
        //
        // },
        // subscriptionCustomFieldsChanged:(data)=>{
        //   console.log("subscriptionCustomFieldsChanged")
        //
        // },
        // subscriptionReactivated: async (data) => {
        //   console.log("subscription reactivated");
        //   self.handled = true;
        //   if(data && data.subscription && data.subscription.id){
        //     let res = await self.ZpDataService.chargeBeeSaveSubscriptionId(data.subscription.id);
        //     if(res.success){
        //       self.user = await self.ZpDataService.getUser();
        //
        //       switch(self.user.userType){
        //         case 'professionalManager':
        //           self.router.navigate(['/professional-manager-home-page']);
        //           break;
        //         case 'professional':
        //           self.router.navigate(['/professional-home-page']);
        //           break;
        //         case 'planHolder':
        //         default:
        //           self.router.navigate(['/home']);
        //       }
        //     }else{
        //       self.ZpDataService.logout();
        //     }
        //   }
        // },
        // subscriptionChanged:async (data) => {
        //   self.handled = true;
        //   if(data && data.subscription && data.subscription.id){
        //     let res = await self.ZpDataService.chargeBeeSaveSubscriptionId(data.subscription.id);
        //     if(res.success){
        //       self.user = await self.ZpDataService.getUser();
        //
        //       switch(self.user.userType){
        //         case 'professionalManager':
        //           self.router.navigate(['/professional-manager-home-page']);
        //           break;
        //         case 'professional':
        //           self.router.navigate(['/professional-home-page']);
        //           break;
        //         case 'planHolder':
        //         default:
        //           self.router.navigate(['/home']);
        //       }
        //     }else{
        //       self.router.navigate(['/log-in']);
        //     }
        //   }
        // },
        visit: (value) => {
          console.log(value);
        }
      });

    }, 300);
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
  }

}
